import { render, staticRenderFns } from "./AddedNewDocumentRequest.vue?vue&type=template&id=5e5de024&scoped=true&"
import script from "./AddedNewDocumentRequest.vue?vue&type=script&lang=js&"
export * from "./AddedNewDocumentRequest.vue?vue&type=script&lang=js&"
import style0 from "./AddedNewDocumentRequest.vue?vue&type=style&index=0&id=5e5de024&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5de024",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDialog,VForm,VIcon,VRadio,VRadioGroup,VTextField})
